import { createSlice } from "@reduxjs/toolkit";

const initialState={
    sigupData:null,
    loading:false,
    token:localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : null,
    }

    const authSlice = createSlice({
        name:"auth",
        initialState:initialState,
        reducers:{
            setSingupData(state,value){
                state.sigupData = value.payload;
            },
            setLoading(state,value){
                state.loading = value.payload;
            },
            setToken(state,value){
                state.token = value.payload;
            },

        }
    })

    export const { setSingupData, setLoading, setToken } = authSlice.actions;

    export default authSlice.reducer;